export enum MediaProcessType {
    VIDEOTELEMETRY_WATERMARK
}